module.exports = __webpack_public_path__ + "assets/icon-trash.58be3071.svg";